import { Unit } from "./unit.model";
import { ProductOption } from './product-option.model';
import { NominativeVouchers } from "./nominative-voucher.model";
export class Sale{
    id: number;
    date: Date;
    dateStr: string;
    initTime: string;
    endTime: string;
    openTime: Object;
    productOption: ProductOption;
    units: Unit[];
    nominativeVouchers: NominativeVouchers[];
}